import React from 'react';
import { Cancel } from '@mui/icons-material';
import {
  Box,
  Card,
  CardContent,
  IconButton,
  Modal,
  Stack,
  TextField,
  Typography,
  Button
} from '@mui/material';
import { Controller, useForm } from 'react-hook-form';
import { getAnalizeReport } from '../../../services/request';

import { styled } from '@mui/material/styles';
import { useQuery, useMutation } from 'react-fetching-library';
import { DateRangePickerDay as MuiDateRangePickerDay } from '@mui/x-date-pickers-pro/DateRangePickerDay';
import { AdapterDateFns } from '@mui/x-date-pickers-pro/AdapterDateFns';
import { LocalizationProvider, DateRangePicker } from '@mui/x-date-pickers-pro';
import { formatDate } from '../../../services/functions';
import toast from 'react-hot-toast';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: {
    xs: '90%',
    md: 400,
    lg: 600
  },
  maxHeight: '100vh',
  display: 'flex',
  flexDirection: 'column'
};

export default function CreateSummaryModal({ open, handleClose }) {
  const { mutate, loading } = useMutation(getAnalizeReport);


  const handleDownloadReport = async data => {
    const { error, payload } = await mutate(data);
    if (!error) {
      const url = window.URL.createObjectURL(payload);
      const a = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display: none';
      a.href = url;
      a.download = 'Raport porównawczy.xlsx';
      a.click();
      window.URL.revokeObjectURL(url);
      handleClose();

      return { error: false, payload };

      toast.error('Nie udało się pobrać raportu');

      return { error: true, payload: null };
    }
  };

  const {
    control,
    handleSubmit,
    formState: { errors }
  } = useForm({
    defaultValues: {
      analysisPeriod: [null, null],
      comparisonPeriod: [null, null]
    }
  });

  const onSubmit = handleSubmit(async data => {
    // alert(JSON.stringify(data, null, 2));
    const { error, payload } = await handleDownloadReport(data);
    if (!error) {
      console.log('confirmed');
    } else {
      console.log('error');
    }
  });

  return (
    <Modal open={open} onClose={handleClose}>
      <Card
        sx={{
          ...style
        }}
      >
        <CardContent
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            p: 7,
            position: 'relative'
          }}
        >
          <IconButton
            color="primary"
            onClick={handleClose}
            sx={{
              position: 'absolute',
              top: 0,
              right: 0
            }}
          >
            <Cancel fontSize="large" />
          </IconButton>
          <form onSubmit={handleSubmit(onSubmit)} style={{ width: '100%' }}>
            <Typography variant="h6" gutterBottom>
              Okres analizy
            </Typography>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <Controller
                name="analysisPeriod"
                control={control}
                rules={{
                  validate: value => (value[0] !== null && value[1] !== null) ||
                    'Wypełnij oba pola'
                }}
                render={({ field }) => (
                  <DateRangePicker
                    {...field}
                    startText="Początkowa data"
                    endText="Końcowa data"
                    renderInput={(startProps, endProps) => (
                      <Stack direction="row" spacing={2}>
                        <TextField
                          {...startProps}
                          fullWidth
                          error={errors.analysisPeriod}
                          helperText={errors.analysisPeriod?.message}
                        />
                        <TextField
                          {...endProps}
                          fullWidth
                          error={errors.analysisPeriod}
                        />
                      </Stack>
                    )}
                  />
                )}
              />
            </LocalizationProvider>
            <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>
              Okres porównania
            </Typography>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <Controller
                name="comparisonPeriod"
                control={control}
                rules={{
                  validate: value => (value[0] !== null && value[1] !== null) ||
                    'Wypełnij oba pola'
                }}
                render={({ field }) => (
                  <DateRangePicker
                    {...field}
                    startText="Początkowa data"
                    endText="Końcowa data"
                    renderInput={(startProps, endProps) => (
                      <Stack direction="row" spacing={2}>
                        <TextField
                          {...startProps}
                          fullWidth
                          error={errors.comparisonPeriod}
                          helperText={errors.comparisonPeriod?.message}
                        />
                        <TextField
                          {...endProps}
                          fullWidth
                          error={errors.comparisonPeriod}
                        />
                      </Stack>
                    )}
                  />
                )}
              />
            </LocalizationProvider>
            <Button
              variant="contained"
              color="primary"
              type="submit"
              disabled = {loading}
              fullWidth
              sx={{ mt: 2 }}
            >
              Generuj
            </Button>
          </form>
        </CardContent>
      </Card>
    </Modal>
  );
}
